import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';

interface BaseFieldProps {
  name: string;
  label: string;
  disabled?: boolean;
  form: UseFormReturn<any>;
  description?: string;
  className?: string;
}

interface InputFieldProps extends BaseFieldProps {
  type: 'input';
  placeholder?: string;
  inputType?: string;
  min?: string;
  max?: string;
}

interface SelectFieldProps extends BaseFieldProps {
  type: 'select';
  placeholder?: string;
  options: Array<{ value: string; label: string }>;
}

type SettingsFieldProps = InputFieldProps | SelectFieldProps;

export const SettingsField: React.FC<SettingsFieldProps> = (props) => {
  const { name, label, disabled = false, form, description, className } = props;

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={`space-y-2 ${className || ''}`}>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <FormLabel className={`sm:w-48 sm:flex-shrink-0 ${disabled ? "text-muted-foreground" : ""}`}>
              {label}
            </FormLabel>
            <FormControl>
              <div className="w-full sm:w-80">
                {props.type === 'input' ? (
                  <Input
                    type={props.inputType || 'text'}
                    placeholder={props.placeholder}
                    min={props.min}
                    max={props.max}
                    disabled={disabled}
                    {...field}
                    onChange={(e) => {
                      if (props.inputType === 'number') {
                        field.onChange(parseInt(e.target.value) || 0);
                      } else {
                        field.onChange(e.target.value);
                      }
                    }}
                  />
                ) : (
                  <Select 
                    onValueChange={field.onChange} 
                    defaultValue={field.value} 
                    disabled={disabled}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder={props.placeholder} />
                    </SelectTrigger>
                    <SelectContent>
                      {props.options.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                          {option.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                )}
              </div>
            </FormControl>
          </div>
          {description && <FormDescription className="text-xs">{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};